// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__main___jL4nK {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-left: 260px;
    padding-bottom: 8vh;
    min-height: 90vh;
    padding-top: var(--navbar-height);
}

.style__screenContainer___GB486 {
    display: flex;
    /*padding: 3vw;*/
    flex-direction: column;
    overflow-x: hidden;
    padding-left: 52px;
    padding-top: 20px;

    /*min-height: 100vh;*/
    width: 100%;
}

.style__sectionTitleContainer___OeYaM {
    border-bottom: 1px solid lightgrey;
    padding-bottom: 1vh;
}

.style__sectionTitle___Vj7Wb {
    font-weight: bold;
    font-size: 15px;
}

.style__sectionCount___AAQB2 {
    font-size: 15px;
    color: grey;
}

.style__stackContainer___a4fbB {
    display: flex;
    flex-direction: row;
    margin-bottom: 2vh;
}

.style__stackItem___yexul {
    display: flex;
    justify-content: center;
    align-items: center;
}

.style__stackItemTitle___FAZi5 {
    font-size: 20px;
    transition: background-color 0.3s ease;
    padding: 8px;
    border-radius: 10px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.style__stackItemTitle___FAZi5:hover {
    background-color: var(--hover-color);
}

.style__resultsTitle___vEQTx {
    font-size: 18px;
    padding: 8px;
    border-radius: 10px;
    margin-top: -2vh;
    margin-bottom: 2vh;
}


.style__emptyText___vUwpi {
   font-size: 18px;
    align-self: center;
    display: flex;
    font-weight: bold;
    color: grey;
    margin-top: 100px;
}
`, "",{"version":3,"sources":["webpack://./src/client/VaultScreen/style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;;IAEjB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,sCAAsC;IACtC,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;;AAGA;GACG,eAAe;IACd,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,WAAW;IACX,iBAAiB;AACrB","sourcesContent":[".main {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-left: 260px;\n    padding-bottom: 8vh;\n    min-height: 90vh;\n    padding-top: var(--navbar-height);\n}\n\n.screenContainer {\n    display: flex;\n    /*padding: 3vw;*/\n    flex-direction: column;\n    overflow-x: hidden;\n    padding-left: 52px;\n    padding-top: 20px;\n\n    /*min-height: 100vh;*/\n    width: 100%;\n}\n\n.sectionTitleContainer {\n    border-bottom: 1px solid lightgrey;\n    padding-bottom: 1vh;\n}\n\n.sectionTitle {\n    font-weight: bold;\n    font-size: 15px;\n}\n\n.sectionCount {\n    font-size: 15px;\n    color: grey;\n}\n\n.stackContainer {\n    display: flex;\n    flex-direction: row;\n    margin-bottom: 2vh;\n}\n\n.stackItem {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.stackItemTitle {\n    font-size: 20px;\n    transition: background-color 0.3s ease;\n    padding: 8px;\n    border-radius: 10px;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n}\n\n.stackItemTitle:hover {\n    background-color: var(--hover-color);\n}\n\n.resultsTitle {\n    font-size: 18px;\n    padding: 8px;\n    border-radius: 10px;\n    margin-top: -2vh;\n    margin-bottom: 2vh;\n}\n\n\n.emptyText {\n   font-size: 18px;\n    align-self: center;\n    display: flex;\n    font-weight: bold;\n    color: grey;\n    margin-top: 100px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `style__main___jL4nK`,
	"screenContainer": `style__screenContainer___GB486`,
	"sectionTitleContainer": `style__sectionTitleContainer___OeYaM`,
	"sectionTitle": `style__sectionTitle___Vj7Wb`,
	"sectionCount": `style__sectionCount___AAQB2`,
	"stackContainer": `style__stackContainer___a4fbB`,
	"stackItem": `style__stackItem___yexul`,
	"stackItemTitle": `style__stackItemTitle___FAZi5`,
	"resultsTitle": `style__resultsTitle___vEQTx`,
	"emptyText": `style__emptyText___vUwpi`
};
export default ___CSS_LOADER_EXPORT___;
